import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { ConsentName } from '@gig/magic-sdk/dist/adapter/users/userPendingConsents';

var _a;
var CONSENTS_NAMESPACE = 'CONSENTS_NAMESPACE';
var SET_PENDING_CONSENTS = 'SET_PENDING_CONSENTS';
var consentGetters = {
    pendingConsents: function (state) {
        return state.pendingConsents.filter(function (_a) {
            var isMandatory = _a.isMandatory, name = _a.name;
            return isMandatory && name !== ConsentName.DETAILS_REVERIFICATION;
        });
    },
};
var consentActions = {
    clearPendingConsents: function (_a) {
        var commit = _a.commit;
        commit(SET_PENDING_CONSENTS, []);
    },
    fetchPendingConsents: function (_a, language) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var isPepBlocked, consents;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY)];
                    case 1:
                        isPepBlocked = _b.sent();
                        if (isPepBlocked) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, magic.methods.users.getUserConsents(language)];
                    case 2:
                        consents = _b.sent();
                        // Check if we're logged in after the call has completed...
                        if (!!magic.session.getUser()) {
                            commit(SET_PENDING_CONSENTS, consents.filter(function (_a) {
                                var consented = _a.consented;
                                return !consented;
                            }));
                        }
                        return [2 /*return*/, consents];
                }
            });
        });
    },
};
var consent = {
    namespaced: true,
    state: {
        pendingConsents: [],
    },
    getters: consentGetters,
    actions: consentActions,
    mutations: (_a = {},
        _a[SET_PENDING_CONSENTS] = function (state, consents) {
            state.pendingConsents = consents;
        },
        _a),
};

export { CONSENTS_NAMESPACE, SET_PENDING_CONSENTS, consent, consentActions, consentGetters };
